import { render, staticRenderFns } from "./InputServiciosEnVenta.vue?vue&type=template&id=73a0d2ff&scoped=true&lang=pug&"
import script from "./InputServiciosEnVenta.vue?vue&type=script&lang=js&"
export * from "./InputServiciosEnVenta.vue?vue&type=script&lang=js&"
import style0 from "./InputServiciosEnVenta.vue?vue&type=style&index=0&id=73a0d2ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a0d2ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VSimpleTable,VTextField})
